import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Background from "@/assets/images/account-creation/background.png"

export default /*#__PURE__*/_defineComponent({
  __name: 'template',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "header"),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "w-full flex justify-center items-center bg-clip-border bg-cover bg-origin-border bg-no-repeat bg-center min-h-screen px-5 py-5",
          style: _normalizeStyle({ 'background-image': `url(${_unref(Background)})` })
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 4)
      ]),
      _: 3
    })
  ], 64))
}
}

})